import React from 'react';
import logo from '../../image/logos-24.svg'

function Erro404({history}) {
    return (
      <div style={{display: "flex", alignItems: 'center', justifyContent: 'center', height: "100vh", flexDirection: 'column' }}>
        <img
            src={logo}
            height="150"
            style={{height: 150}}
            alt="logo"
            />
        <h1 style={{color: "var(--main-bg-color)"}}>Erro 404</h1>
        <h1 style={{color: "var(--main-bg-color)"}}>Pagina não encontrada</h1>
      </div>
    );
}

export default Erro404;